import { Accordion, AccordionSummary, Grid, Skeleton } from '@mui/material'
import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import clsx from "clsx";

// Placeholder rows shown while the agent data for the thread is still loading.
const AGENT_ROW_COUNT = 2;

const AgentRowSkeleton: React.FC = () => (
    <Accordion expanded={false} className={clsx(styles.agentAccordion, styles.chatInfoBlockAgentDataAccordion)}>
        <AccordionSummary
            className={styles.chatInfoBlockAgentDataAccordionSummary}
        >
            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                <Grid item>
                    <Grid container gap={"10px"} alignItems={"center"}>
                        <Grid item>
                            <Skeleton variant="circular" width={28} height={28} />
                        </Grid>
                        <Grid item>
                            <Skeleton variant="text" width={120} height={20} />
                        </Grid>
                        <Grid item>
                            <Skeleton variant="circular" width={10} height={10} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={styles.deleteAgentIconGrid}>
                    <Skeleton variant="circular" width={16} height={16} />
                </Grid>
            </Grid>
        </AccordionSummary>
    </Accordion>
);

/**
 * Skeleton loader for the Agent Data tab (ChatInformationBlock > InfoPanel > AgentDataTabContent).
 * Shown while isInfoTabLoading is true in ruleBasedInboxStore.
 */
const AgentDataTabSkeleton: React.FC = () => (
    <Grid container direction="column" spacing={2} className={styles.chatInfoBlockAgentDataContainer}>
        {Array.from({ length: AGENT_ROW_COUNT }).map((_, index) => (
            <Grid item key={index}>
                <AgentRowSkeleton />
            </Grid>
        ))}
    </Grid>
);

export default React.memo(AgentDataTabSkeleton);
